// Set top-level elements we want to target
const targets_children = [
	":where(main, .single-content) .wp-block-columns .wp-block-column:has(> .acf-card)",
	":where(main, .single-content) > .wp-block-columns",
	":where(main, .single-content) .wp-block-gallery",
];
const targets_self = [
	":where(main, .single-content) > .wp-block-cover > .wp-block-cover__inner-container",
	":where(main, .single-content) > .wp-block-media-text > .wp-block-media-text__content",
	":where(main, .single-content) > .wp-block-group:not(:has([data-reveal]))", // This needs to go last, as we want other things to take precedent
];

function sectionRevealAnimations() {
	// Do nothing if IntersectionObserver isn't supported
	if (!("IntersectionObserver" in window)) {
		console.log("IntersectionObserver is not supported");
		return false;
	}
	// Do nothing if browser is set to reduced motion
	if (!window.matchMedia("(prefers-reduced-motion: no-preference)")) {
		console.log("browser either doesn't support prefers-reduced-motion or is set to prefers-reduced-motion: reduced");
		return false;
	}

	const observerThreshold = 0.125;

	// Set up observer
	var sectionObserver = new IntersectionObserver(
		function (entries, observer) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting || entry.boundingClientRect.y < 0) {
					entry.target.setAttribute("data-reveal-state", "visible");
					observer.unobserve(entry.target);
				}
			});
		},
		{ threshold: observerThreshold }
	);

	var elements_children = document.querySelectorAll(targets_children.join(", "));
	elements_children.forEach(function (element) {
		element.setAttribute("data-reveal", "children");
	});

	var elements_self = document.querySelectorAll(targets_self.join(", "));
	elements_self.forEach(function (element) {
		element.setAttribute("data-reveal", "self");
	});

	// Activate observer
	var sections = document.querySelectorAll("[data-reveal]");
	sections.forEach(function (element) {
		element.setAttribute("data-reveal-state", "watching");
		sectionObserver.observe(element);
	});
}
sectionRevealAnimations();
